<template>
  <NuxtChild :product="product" :initial-comments="initialComments" />
</template>

<script>
export default {
  name: 'ProductPageMain',
  async asyncData ({ app, params, query, redirect, error }) {
    const emptyComments = {
      elements: [],
      quantity: null,
      ratesInTotal: 0,
      averageRate: null,
      all: 0
    }
    const product = await app.$api.default.getProduct(params.productId).catch(() => null)
    const initialComments = product && product.id
      ? await app.$api.comment.offer(product.id, {
        page: 1,
        limit: 10,
        rating: null,
        id: query.rateId || null
      }).catch(() => emptyComments)
      : emptyComments
    if (!product || !product.offerProduct || !product.offerProduct.link) {
      return error({ statusCode: 404, message: 'Product not found' })
    }

    const productName = product.offerProduct.link
    if (params.productName !== productName || Number(params.productId) !== product.offerProduct.id) {
      return redirect(301, app.localePath({ name: 'product', params: { productName, productId: product.offerProduct.id } }))
    }
    return { product, initialComments }
  },
  head () {
    return {
      title: this.$t('fields.product')
    }
  }
}
</script>
